import { Injectable } from '@angular/core';
import { CurrentCommentAction } from '../action/current-comment.action';
import { CdxComment, CdxReply } from '../../../models/cdx-comment';

@Injectable({
  providedIn: 'root'
})
export class CurrentCommentService {

constructor(private currentCommentAction: CurrentCommentAction) { }

  setCurrentComment(comment: CdxComment, isFromError = false) {
    try {
      this.currentCommentAction.loadCurrentCommentStart();
      if (comment === undefined || comment === null) {
        throw new ErrorEvent('comment cannot be null or undefined');
      }
      this.currentCommentAction.loadCurrentCommentSucceeded(comment, isFromError);
    } catch (error) {
      this.currentCommentAction.loadCurrentCommentFailed(error.message);
    }
  }

  setCurrentReply(reply: CdxReply) {
    try {
      this.currentCommentAction.loadCurrentReplyStart();
      if (reply === undefined || reply === null) {
        throw new ErrorEvent('reply cannot be null or undefined');
      }
      this.currentCommentAction.loadCurrentReplySucceeded(reply);
    } catch (error) {
      this.currentCommentAction.loadCurrentReplyFailed(error.message);
    }
  }

  removeCurrentComment() {
      this.currentCommentAction.removeComment();
  }

}
